import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white font-poppins mb-24" }

import Title from '../components/content/Title.vue';
import { Brand } from '../services/integration/enums';
import HeroText from '../components/content/HeroText.vue';
import Container from '../components/content/Container.vue';
import HelpOptions2 from '../components/content/HelpOptions2.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotServiceable',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const contacts = brandService.getContacts();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createVNode(HeroText, {
          class: "pt-20",
          title: "This is awkward.",
          subtitle: "Unfortunately, we can't offer you internet at your address :("
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Container, null, {
        default: _withCtx(() => [
          _createVNode(Title, {
            class: "mb-4",
            title: "How can we help?",
            centered: true,
            id: "contact"
          }),
          (_unref(brandService).getName() === _unref(Brand).NEX)
            ? (_openBlock(), _createBlock(HelpOptions2, {
                key: 0,
                class: "pb-20",
                features: _unref(contacts)
              }, null, 8, ["features"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})